import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export const BASE_URL = 'https://spinningwesterlo.be';
export const DEFAULT_DESCRIPTION =
  'Spinninglessen voor elk niveau bij Heracles Westerlo. ' +
  'Lessen op maandag, dinsdag, woensdag en donderdag. Reserveer online of boek een gratis proefles.';

/**
 * Houdt de meta description, robots-tag en canonical link in sync met de actieve route.
 * Route data: `description` (publieke pagina's) en `noindex` (auth/admin-pagina's).
 */
@Injectable({ providedIn: 'root' })
export class SeoService {
  constructor(
    private readonly router: Router,
    private readonly meta: Meta,
  ) {}

  init(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        const data = this.deepestRouteData();
        const description =
          typeof data['description'] === 'string'
            ? data['description']
            : DEFAULT_DESCRIPTION;
        this.meta.updateTag({ name: 'description', content: description });
        if (data['noindex']) {
          this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
        } else {
          this.meta.removeTag('name="robots"');
        }
        const path = event.urlAfterRedirects.split('?')[0].split('#')[0];
        this.setCanonical(BASE_URL + path);
      });
  }

  private deepestRouteData(): Record<string, unknown> {
    let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    let data: Record<string, unknown> = {};
    while (route) {
      data = { ...data, ...route.data };
      route = route.firstChild!;
      if (!route) {
        break;
      }
    }
    return data;
  }

  private setCanonical(url: string): void {
    let link = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
